import axios from "axios";
import { identity } from "lodash";
import { HttpClient } from "../../../../httpClient";
// import {URL} from '../../../src/utils/config'
const eventTypeMap = {
  GB: "GET_HMRC_REQUEST_MESSAGE",
  US: "GET_CBP_REQUEST_MESSAGE",
  CA: "GET_CBSA_REQUEST_MESSAGE",
  CA_CARM: "GET_ALL_TRANSACTION_REQUEST_CARM"
};
const eventCreateRecord = {
  GB: "CREATE_HMRC_DOCUMENT",
  US: "CREATE_ES_DOCUMENT",
  CA: "CREATE_CBSA_DOCUMENT",
};
const eventDeleteRecord = {
  GB: "DELETE_HMRC_DOCUMENT",
  US: "DELETE_ES_DOCUMENT",
  CA: "DELETE_CBSA_DOCUMENT",
};

const typeInCountry = {
  GB: "cspType",
  US: "type",
  CA: "type",
};
const typeInCountryEDIRequest = {
  GB: "cspType",
  US: "type",
  CA: "formType",
};
const requestType = {
  GB: "HMRC_NEW",
  US: "CBP_NEW",
  CA: "CBSA_NEW",
};
const fileEdiEventType = {
  GB: "FILE_HMRC_REQUEST",
  US: "FILE_EDI_REQUEST",
  CA: "FILE_CBSA_REQUEST",
};
const fileEdiRequestType = {
  GB: "cspType",
  US: "documentType",
  CA: "documentType",
};
const createRequestType = {
  GB: "type",
  US: "type",
  CA: "formType",
};

class edi {
  getCbpRequest = (payload, country, US_FORM_TYPE, isPscRequest=false) => {
    //debugger;
    let data = {
      eventMessage: {
        shipmentid: payload,
        filterOutUnsentRequest: true,
      },
      eventType: eventTypeMap[country],
      eventTime: Date.now(),
    };
    if (isPscRequest) {
      data.eventMessage.createPSC = 1;
    }
    if(country === 'US'){
      data.eventMessage.filterOutUnsentRequest =  true
    }

    return HttpClient.custom({
      data,
    });
  };

  getCarmRecords = () => {
    let data = {
      eventMessage: {
        transactionNumber: window.transactionNumber
      },
      eventTime: Date.now(), 
     eventType: eventTypeMap["CA_CARM"]
    }
    return HttpClient.custom({
      data,
    });
  }

  fileCarmRecords = ({shipmentid, xml, event, useCBSAEnvironment}) => {
    let data = {
      eventMessage: {
        shipmentid,
        txnNumber: window.transactionNumber,
        xml,
        isLvs: false,
        CBSAEDIFormat: "CAD_XML",
        useCBSAEnvironment: useCBSAEnvironment,
      },
      eventTime: Date.now(),
      eventType: event
    }
    return HttpClient.custom({
      data,
    });
  }

  getRequestRecords = (
    payload,
    country,
    generateEDI,
    type,
    shipmentid,
    selectedRow = null
  ) => {
    let data = {
      eventMessage: {
        requestid: payload,
        generateEDI: generateEDI,
        shipmentid: shipmentid,
        [typeInCountryEDIRequest[country]]: type,
      },
      eventType: eventTypeMap[country],
      eventTime: Date.now(),
    };
    if (country === "GB") {
      data.eventMessage.requestType = requestType[country];
    }
    if (country === "CA") {
      data.eventMessage.ediFormat = selectedRow.ediFormat;
      data.eventMessage.action = selectedRow.action;
    }
    return HttpClient.custom({
      data,
    });
  };

  fetchEdiFormat = (payload) => {
    let data = {
      eventMessage: {
        action: payload.action || "ADD",
        doctype: payload.documentType,
      },
      eventType: "GET_EDI_FORMAT",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  };

  createEdiRequest = (payload, country, usFormType, isPscRequest=false) => {
    let data = {
      eventMessage: {
        shipmentid: payload.shipmentId,
        action: payload.actionType,
        [createRequestType[country]]: payload.documentType,
        // type: payload.documentType,
      },
      eventType: eventCreateRecord[country],
      eventTime: Date.now(),
    };
    if (country === "CA") {
      data.eventMessage.ediFormat = payload.ediFormat;
    }
    if (isPscRequest) {
      data.eventMessage.createPSC = 1;
    }
    if (country === "GB") {
      data.eventMessage.requestType = `HMRC_${payload.actionType}`;
    }
    return HttpClient.custom({
      data,
    });
  };
  deleteEdiRequest = (payload, country, usFormType) => {
    let data = {
      eventMessage: {
        requestid: payload,
      },
      eventType: eventDeleteRecord[country],
      eventTime: Date.now(),
    };
    if (country === "US" && usFormType === "PSC") {
      data.eventMessage.createPSC = 1;
    }
    return HttpClient.custom({
      data,
    });
  };

  saveEdiRequest = (payload) => {
    let data = {
      eventMessage: {
        env: "ENV_TEST",
        type: payload.type,
        shipmentid: payload.shipmentid,
        requestid: payload.requestId,
        action: "ADD",
        records: {
          recordlist: [...payload.requestRecord],
        },
      },
      eventType: "UPSERT_CBP_REQUEST_RECORDS",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  };

  GetFileToken = (shipmentid, email, requestid, reason) => {
    let data = {
      eventMessage: {
        requestid: requestid,
        shipmentid: shipmentid || window.shipmentId,
        email: email,
        reason: reason,
      },
      eventType: "GET_FILE_TOKEN",
      eventTime: Date.now(),
    };
    return HttpClient.custom({
      data,
    });
  };

  FileEdiRequest = (
    selectedRow,
    retransmit,
    shipmentid,
    PopUprecords,
    country,
    fileHMRC,
    email,
    token,
    fileCBSA,
    reason,
    usFormType,
    documentType
  ) => {
    let data = {
      eventMessage: {
        shipmentid: shipmentid,
        requestid: selectedRow.requestid,
        email: email,
        token: token,
        fileReason: reason,
        reTransmit: retransmit,
        env: "ENV_PROD",
        [typeInCountry[country]]: selectedRow?.[fileEdiRequestType[country]],
        records: {
          recordlist: PopUprecords.recordlist,
        },
      },
      eventType: fileEdiEventType[country],
      eventTime: Date.now(),
    };
    if (
      country === "US" &&
      usFormType === "PSC" &&
      ["DOC_ENTRY_7501_NON_COMBINED", "DOC_ENTRY_7501"].includes(documentType)
    ) {
      data.eventMessage.createPSC = 1;
    }
    if (country === "GB") {
      data.eventMessage.fileWithHMRC = fileHMRC;
      data.eventMessage.requestType = requestType[country];
    }
    if (country === "CA") {
      data.eventMessage.useCBSAEnvironment = fileCBSA;
      data.eventMessage.ediFormat = selectedRow.ediFormat;
      data.eventMessage.formType = selectedRow.formType;
    }
    return HttpClient.custom({
      data,
    });
  };
}
export default new edi();
